var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { classNames } from "../Util";
export var TableColumnBreakpoint;
(function (TableColumnBreakpoint) {
    TableColumnBreakpoint["ssssm"] = "hidden ssssm:table-cell";
    TableColumnBreakpoint["sssm"] = "hidden sssm:table-cell";
    TableColumnBreakpoint["ssm"] = "hidden ssm:table-cell";
    TableColumnBreakpoint["sm"] = "hidden sm:table-cell";
    TableColumnBreakpoint["md"] = "hidden md:table-cell";
    TableColumnBreakpoint["lg"] = "hidden lg:table-cell";
    TableColumnBreakpoint["xl"] = "hidden xl:table-cell";
    TableColumnBreakpoint["xxl"] = "hidden 2xl:table-cell";
})(TableColumnBreakpoint || (TableColumnBreakpoint = {}));
var TableColumns = function (_a) {
    var columns = _a.columns, _b = _a.sortingDisabled, sortingDisabled = _b === void 0 ? false : _b;
    var plainLabel = function (col) { return (col.hideLabel
        ? _jsx("span", __assign({ className: "sr-only" }, { children: col.name }))
        : _jsx(_Fragment, { children: col.name })); };
    var sortableLabel = function (col) { return (_jsxs("button", __assign({ onClick: col.onClick, disabled: sortingDisabled, className: "group inline-flex disabled:opacity-50 disabled:pointer-events-none" }, { children: [plainLabel(col), col.sortable &&
                _jsx("div", __assign({ className: classNames((col.sortable && col.sorted === undefined) ? "invisible ml-2 flex-none rounded text-gray-400 group-hover:visible group-focus:visible" : "", (col.sorted !== undefined) ? "ml-2 flex-none rounded bg-gray-200 text-gray-900 group-hover:bg-gray-300" : "", (col.sorted !== undefined && col.sorted === "asc") ? "rotate-180" : "") }, { children: _jsx(ChevronDownIcon, { className: "h-5 w-5", "aria-hidden": "true" }) }))] }))); };
    var nonHiddenColumns = columns.filter(function (c) { return !c.hidden; });
    var renderedColumns = nonHiddenColumns.map(function (col, index) {
        var isLast = index === nonHiddenColumns.length - 1;
        return (_jsx("th", __assign({ scope: "col", className: classNames("text-left text-sm font-semibold text-gray-900", index === 0
                ? "px-3 py-4 sm:pl-6"
                : "px-3 py-3.5", "whitespace-nowrap", col.showOnBreakpoint ? col.showOnBreakpoint : "", col.alignRight ? "text-right" : "", isLast ? "pr-4 sm:pr-6" : "", col.thClassName ? col.thClassName : "") }, { children: col.altTh
                ? col.altTh
                : (!col.sortable ? plainLabel(col) : sortableLabel(col)) }), col.name));
    });
    return (_jsx("thead", __assign({ className: "bg-gray-50" }, { children: _jsx("tr", { children: renderedColumns }) })));
};
export default TableColumns;
